import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { Kpis } from './kpi-model';
import { KpiTechnicienComponent } from './kpi-technicien/kpi-technicien.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { getConfigOrElse } from '../../providers/config/config.service';

@Component({
  selector: 'kpis-technicien',
  templateUrl: 'kpis-technicien.modal.html',
  styleUrls: ['kpis-technicien.modal.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule, KpiTechnicienComponent, TranslateModule],
})
export class KpisTechnicienComponent implements OnInit {
  kpis: Kpis;
  objectifFilEau: number;
  objectifRealisation: number;
  objectifAgenda: number;

  constructor(
    private modalCtrl: ModalController,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    console.log(this.kpis);
    this.objectifFilEau = Number(getConfigOrElse('KPI_OBJECTIF_FIL_EAU', '0'));
    this.objectifRealisation = Number(getConfigOrElse('KPI_OBJECTIF_REALISATION', '0'));
    this.objectifAgenda = Number(getConfigOrElse('KPI_OBJECTIF_AGENDA', '0'));
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }
}
